import { useEffect, useState } from 'react';

/**
 * This hook catch angular event
 *
 * - ngLocationChangeSuccess - Trigger when angular router change path
 * Use it only when you'r not in Router context. Otherwise, use useLocation from react-router-dom
 */
export const useNGEvent = () => {
    const [pathname, setPathname] = useState(window.location.pathname);
    const [search, setSearch] = useState(window.location.search);

    const ngChangeSuccess = () => {
        setPathname(window.location.pathname);
        setSearch(window.location.search);
    };

    useEffect(() => {
        window.addEventListener('ngLocationChangeSuccess', ngChangeSuccess);
        return () => {
            window.removeEventListener('ngLocationChangeSuccess', ngChangeSuccess);
        };
    }, []);

    return { pathname, search };
};
